import React from 'react';
import EmployeeDataBase from '../../../generics/components/EmployeeDataBase';

export default function EmployeeData({ formik, preview, fileInputRef, isDefaultPhoto, handlePhotoChange, handleChangeImage, loading }) {
  return <EmployeeDataBase formik={formik} preview={preview} fileInputRef={fileInputRef} isDefaultPhoto={isDefaultPhoto} handlePhotoChange={handlePhotoChange} handleChangeImage={handleChangeImage} loading={loading}/>;
};
